import { Transform } from "../../../../geometry/transformation";

function rotateAnchoredShapeToTransform(shape: AnchoredShape): AnchoredShape {
  const rotationTransform = Transform.rotationTransform(-shape.rot / 180 * Math.PI).translate(shape.x, shape.y).m;
  const posReset = { ...shape, x: 0, y: 0 }
  return { ...posReset, transformation: rotationTransform }
}

function getAnchor(shape: AnchoredShape): Point2d & { rot: number } {
  const tr = new Transform(shape.transformation);
  return { ...tr.point2d(shape), rot: tr.getRotation() * 180 / Math.PI };
}

export {
  rotateAnchoredShapeToTransform,
  getAnchor
}